export default "__VITE_ASSET__Bzz3PFAn__"